import type { SurfaceSelection } from "./surface-selection-pass";
import type { PipeRunSelection } from "./pipe-selection";

export type WandShape = "plane" | "cylinder" | "pipe-run";
export type WandSelection = SurfaceSelection | PipeRunSelection;

/**
 * @param selection Wand result.
 * @returns Whether this is a traced pipe run rather than an analytic surface.
 */
export function isPipeRunSelection(
  selection: WandSelection,
): selection is PipeRunSelection {
  return "kind" in selection;
}

/**
 * @param selection Wand result.
 * @returns Whether this uses the existing planar/cylindrical mask.
 */
export function isAnalyticSelection(
  selection: WandSelection,
): selection is SurfaceSelection {
  return !isPipeRunSelection(selection);
}

/**
 * @param selection Current or retained result.
 * @returns Its matching toolbar shape.
 */
export function wandSelectionShape(selection: WandSelection): WandShape {
  if (isPipeRunSelection(selection)) return "pipe-run";
  return selection.cylinder ? "cylinder" : "plane";
}
